import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Download, CreditCard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Page, PageTitle, Loading, ErrorBox, Empty } from "@/components/site/Common";
import { payInvoice } from "@/components/job/JobChatInvoice";
import { useMe } from "@/hooks/useMe";
import { get, hzFile } from "@/lib/api";
import { eur, fdate } from "@/lib/hz";

const isPaid = (s) => ["pagada", "pagado", "paid"].includes(s);

export default function Invoices() {
  const { data: me } = useMe();
  const q = useQuery({ queryKey: ["invoices"], queryFn: () => get("/invoices") });
  const isClient = me.role === "cliente";
  return (
    <Page>
      <PageTitle eyebrow="Facturas" title={isClient ? "Facturas y pagos" : "Facturas y cobros"} sub="Todas con IVA 21%, descargables en PDF." />
      <div className="mt-8">
        {q.isLoading ? <Loading /> : q.isError ? <ErrorBox /> : !q.data.length ? <Empty>Todavía no hay facturas.</Empty> : (
          <div className="overflow-hidden rounded-3xl border border-slate-200 bg-white" data-testid="invoices-table">
            <Table>
              <TableHeader><TableRow><TableHead>Nº</TableHead><TableHead>Trabajo</TableHead><TableHead>{isClient ? "Profesional" : "Cliente"}</TableHead><TableHead>Fecha</TableHead><TableHead className="text-right">Total</TableHead><TableHead>Estado</TableHead><TableHead /></TableRow></TableHeader>
              <TableBody>
                {q.data.map((i) => (
                  <TableRow key={i.id} data-testid={`invoice-row-${i.id}`}>
                    <TableCell className="font-semibold">{i.number}</TableCell>
                    <TableCell><Link to={`/trabajos/${i.job_id}`} className="hover:text-orange-600">{i.job_title}</Link></TableCell>
                    <TableCell>{isClient ? i.pro_name : i.client_name}</TableCell>
                    <TableCell>{fdate(i.issued_at)}</TableCell>
                    <TableCell className="text-right font-bold">{eur(i.total)}</TableCell>
                    <TableCell><span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${isPaid(i.status) ? "bg-emerald-100 text-emerald-800" : "bg-violet-100 text-violet-800"}`}>{isPaid(i.status) ? "Pagada" : "Pendiente"}</span></TableCell>
                    <TableCell className="text-right">
                      <div className="flex justify-end gap-2">
                        {isClient && !isPaid(i.status) && <Button size="sm" className="rounded-lg" onClick={() => payInvoice(i.id)} data-testid={`pay-${i.id}`}><CreditCard />Pagar</Button>}
                        <Button asChild size="sm" variant="outline" className="rounded-lg"><a href={hzFile(`/invoices/${i.id}/pdf`)} target="_blank" rel="noreferrer" data-testid={`pdf-${i.id}`}><Download />PDF</a></Button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </div>
    </Page>
  );
}
